import { render, staticRenderFns } from "./SampleReels.vue?vue&type=template&id=3982c263&scoped=true"
import script from "./SampleReels.vue?vue&type=script&lang=ts"
export * from "./SampleReels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3982c263",
  null
  
)

export default component.exports